import api from './api';

const withStoreId = (storeId) => (storeId ? { _storeId: storeId } : undefined);

const StoreDataImportService = {
  getCurrent: async (storeId) => {
    const response = await api.get(`/stores/${storeId}/data-imports/current`, withStoreId(storeId));
    return response.status === 204 ? null : response.data;
  },

  importCustomers: async (storeId, payload) => {
    const response = await api.post(
      `/stores/${storeId}/data-imports/customers`,
      payload,
      withStoreId(storeId),
    );
    return response.data;
  },

  importServices: async (storeId, payload) => {
    const response = await api.post(
      `/stores/${storeId}/data-imports/services`,
      payload,
      withStoreId(storeId),
    );
    return response.data;
  },

  importTeamMembers: async (storeId, payload) => {
    const response = await api.post(
      `/stores/${storeId}/data-imports/team-members`,
      payload,
      withStoreId(storeId),
    );
    return response.data;
  },

  importAppointments: async (storeId, payload) => {
    const response = await api.post(
      `/stores/${storeId}/data-imports/appointments`,
      payload,
      withStoreId(storeId),
    );
    return response.data;
  },
};

export default StoreDataImportService;
